import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Card de credit',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Plată prin bancă',
    [PaymentMethod.SepaDebit]: 'EC-Card / IBAN',
    [PaymentMethod.Cash]: 'Numerar',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Altă metodă de plată',
  },
};
